export default __webpack_public_path__ + "static/media/void.3a87c90d.svg";